import { z } from "zod";
import uuid from "./uuid";

export default z.object({
  id: z.string(),
  poster: uuid,
  title: z.string(),
  year: z.number(),
});
